export default "__VITE_ASSET__BFU7SJ2u__"